<template>
    <b-modal
        id="personal-goal-edit-tasks"
        v-model="modal"
        modal-class="apprentice-default-modal personal-goal-edit-task"
        :title="`Taak: ${task.name} bewerken`"
        header-class="personalgoal-edit-task-modal-header"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        size="md"
        @ok="onOk">
        <div
            class="personal-goal-edit-task"
            v-if="task">
            <div
                class="errors"
                v-if="haserror">
                <b-alert
                    variant="danger"
                    show>
                    Naam taak mag niet leeg zijn.
                </b-alert>
            </div>

            <div class="task">
                <b-form-group
                    class="task-name"
                    label="Naam"
                    :label-for="`task-input-${task.id}`">
                    <b-input-group class="personal-task-group">
                        <b-form-input
                            v-model="task.name"
                            placeholder="naam taak"
                            :id="`task-input-${task.id}`">
                        </b-form-input>
                    </b-input-group>
                </b-form-group>

                <b-form-group
                    label="Deadline:"
                    :label-for="`task-deadline-input-${task.id}`">
                    <template v-slot:label> Deadline: </template>

                    <b-input-group class="task-deadline-group">
                        <b-input-group-append>
                            <b-form-datepicker
                                class="apprentice-date-picker btn-date-group"
                                v-model="task.deadline"
                                :id="`task-deadline-input-${task.id}`"
                                start-weekday="1"
                                now-button
                                reset-button
                                right
                                today-variant="primary"
                                nav-button-variant="primary"
                                locale="nl"
                                aria-controls="Kies een datum"
                                label-reset-button="reset"
                                label-no-date-selected="Kies een datum"
                                menu-class="datedropdown"
                                :date-format-options="{
                                    year: 'numeric',
                                    month: 'short',
                                    day: '2-digit',
                                    weekday: 'short',
                                }">
                            </b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-personal-goal-edit-task-modal-component',
    props: {},
    data() {
        return {
            modal: false,
            task: {},
            haserror: false,
        };
    },

    methods: {
        show(task) {
            this.task = task;
            if (
                task.personal_goal_task_deadline !== null &&
                typeof task.personal_goal_task_deadline === 'object' &&
                task.personal_goal_task_deadline.agenda_item !== null &&
                typeof task.personal_goal_task_deadline.agenda_item === 'object'
            ) {
                this.task.deadline = task.personal_goal_task_deadline.agenda_item.date;
            } else {
                this.task.deadline = '';
            }

            this.modal = true;
        },

        onOk(bvModalEvt) {
            if (!this.isTaskValidated()) {
                this.haserror = true;
                bvModalEvt.preventDefault();
                return;
            }

            const data = {
                task_name: this.task.name,
            };

            if (this.task.deadline !== '') {
                data.task_deadline = this.task.deadline;
            }

            this.alert.saving();
            this.axios.post(this.routes.personalGoalTaskUpdate(this.task.id), data).then(
                (response) => {
                    this.task.update(response.data);
                    this.alert.success();
                    this.$emit('personal-goal-task-updated', response.data);
                },

                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        isTaskValidated() {
            this.haserror = false;

            return this.task.name !== '' && this.task.name !== null;
        },
    },
};
</script>

<style scoped lang="scss">
.task-deadline-group ::v-deep {
    .input-group-append {
        flex: 1;
    }
}
</style>
